module.exports = __webpack_public_path__ + "img/wolf_8.39546512.jpg";